export default "__VITE_ASSET__32345226__"